<script lang="ts" generics="TValues, TRequired extends true|false">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import Select from '$components/Form/Select.svelte';
    import countries from '$components/Form/SelectCountry/country';
    import CountryPicture from '$components/CountryPicture.svelte';
    import deburr from 'lodash/deburr';

    export let placeholder = '';

    export let required: TRequired;
    export let form: Form<TValues, string>;
    export let field: Field<TValues, TRequired extends true ? string : string | null>;
    export let disableClearable = false;
    export let id: string | null = null;

    let className: string = '';
    export { className as class };

    const options = countries.map((c) => ({ key: c.value, ...c }));
</script>

<Select
    {form}
    {field}
    {placeholder}
    {options}
    {disableClearable}
    {id}
    {required}
    showChevron
    itemFilter={(label, filterText) => {
        const deburrLabel = deburr(label.toLowerCase()).replaceAll(/[^a-zA-Z0-9]+/g, '');
        const deburrFilterText = deburr(filterText.toLowerCase()).replaceAll(
            /[^a-zA-Z0-9]+/g,
            '',
        );

        return deburrLabel.includes(deburrFilterText);
    }}
    class={className}
>
    <div slot="option" let:option class="px-4 py-2 flex items-center gap-4">
        <CountryPicture
            country={`${option.value}`}
            size={'48'}
            style={'shiny'}
            class="w-30px ls:w-40px h-auto hover:filter-saturate-2"
        />
        {option.label}
    </div>
</Select>
